const scriptPromises = new Map<string, Promise<void>>();
const READY_ATTRIBUTE = "data-afiliabr-script-ready";

function applyAttributes(script: HTMLScriptElement, attributes: Record<string, string>) {
  Object.entries(attributes).forEach(([key, value]) => {
    script.setAttribute(key, value);
  });
}

function waitForScript(script: HTMLScriptElement, scriptId: string) {
  if (script.getAttribute(READY_ATTRIBUTE) === "true") {
    return Promise.resolve();
  }

  const existingPromise = scriptPromises.get(scriptId);
  if (existingPromise) {
    return existingPromise;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const handleLoad = () => {
      script.setAttribute(READY_ATTRIBUTE, "true");
      scriptPromises.delete(scriptId);
      resolve();
    };

    const handleError = () => {
      script.setAttribute(READY_ATTRIBUTE, "false");
      scriptPromises.delete(scriptId);
      reject(new Error(`Falha ao carregar script: ${scriptId}`));
    };

    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });
  });

  scriptPromises.set(scriptId, promise);
  return promise;
}

export function loadHeadScriptOnce(scriptId: string, src: string, attributes: Record<string, string> = {}) {
  const existingScript = document.getElementById(scriptId) as HTMLScriptElement | null;

  if (existingScript && existingScript.src !== src) {
    existingScript.remove();
    scriptPromises.delete(scriptId);
  }

  const stableScript = (document.getElementById(scriptId) as HTMLScriptElement | null) ?? null;
  if (stableScript) {
    applyAttributes(stableScript, attributes);
    return waitForScript(stableScript, scriptId);
  }

  const script = document.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = src;
  applyAttributes(script, attributes);

  const promise = waitForScript(script, scriptId);
  document.head.appendChild(script);
  return promise;
}

export function removeHeadScript(scriptId: string) {
  document.getElementById(scriptId)?.remove();
  scriptPromises.delete(scriptId);
}

export function hasHeadScript(scriptId: string, src?: string) {
  const script = document.getElementById(scriptId) as HTMLScriptElement | null;
  if (!script) return false;
  if (!src) return true;
  return script.src === src;
}
